/** 渲染的下拉菜单数量 */
export const ITEM_ELEMENT_NUMBER = 30;
/** 下拉列表高度 */
export const DROPDOWN_HEIGHT = 250;
export const SELECT_MODE: any[] = ['tags', 'multiple'];
export const ITEM_HEIGHT = 40;
export const VISIBLE_DOM_HEIGHT = ITEM_HEIGHT * ITEM_ELEMENT_NUMBER; // 可视区dom高度
export const REACT_DELTA = VISIBLE_DOM_HEIGHT / 3; // 滚动时重新渲染的scrollTop判断值，大于 reactDelta 则刷新下拉列表
